import React, { useEffect, useState } from 'react';
import { deleteTodo, editTodo, editTodoDeadlineDate, editTodoStatus, findSearchedTodo, removeTodoDeadlineDate, sendTodoListByEmail } from '../apiCallsHelper/todoapicalls';
import { createTask } from '../apiCallsHelper/taskapicalls';
import { isAuthenticated } from '../apiCallsHelper/authapicalls';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faFileLines, faFolderClosed, faFolderOpen, faMagnifyingGlass, faPenToSquare, faSortDown, faTrash } from '@fortawesome/free-solid-svg-icons';
import SortDropdown from '../utils/SortDropdown';
import Checkbox from '../utils/Checkbox';
import ModalForm from '../utils/ModalForm';
import ModalAlert from '../utils/ModalAlert';
import MyModal from '../utils/MyModal';
import { toast } from 'react-toastify';
import { MagnifyingGlass } from 'react-loader-spinner';
import LoadingOverlay from '../utils/LoadingOverlay';
import moment from "moment";
import '../styles.css';



const TodoList = ({ todos, setTodos, setIsTodos, findTodo, setFindTodo, activeTodo, setActiveTodo, isTaskAdded, setIsTaskAdded, setIsTodoEdited, isTodoEdited }) => {

    const { user, token } = isAuthenticated();

    const [isEdited, setIsEdited] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);
    const [isTodoCompleted, setIsTodoCompleted] = useState(false);
    const [isTodoChecked, setIsTodoChecked] = useState(false);
    const [isTodoClicked, setIsTodoClicked] = useState(null);

    //sort todo
    const [isOpenSort, setIsOpenSort] = useState(false);
    const [sortOption, setSortOption] = useState("Default");
    const [sortedTodos, setSortedTodos] = useState(todos);

    //todo due date
    const [isDeadlineUpdated, setIsDeadlineUpdated] = useState(false);
    const [activeDeadlineTodo, setActiveDeadlineTodo] = useState(null);
    const [currentDeadlineDate, setCurrentDeadlineDate] = useState(null);
    const [isDateEditMode, setIsDateEditMode] = useState(false);
    const [isDateSaveMode, setIsDateSaveMode] = useState(false);

    //edit todo - ModalForm
    const [isOpenModalForm, setIsOpenModalForm] = useState(false);
    const [editTodoId, setEditTodoId] = useState(null);
    const [modalInput, setModalInput] = useState("");

    //edit todo - ModalAlert
    const [isOpenModalAlert, setIsOpenModalAlert] = useState(false);

    //add todo - ModalForm
    const [isOpenAddModalForm, setIsOpenAddModalForm] = useState(false);
    const [addTodoId, setAddTodoId] = useState(null);
    const [addModalInput, setAddModalInput] = useState("");

    //delete todo - MyModal
    const [isOpenMyModal, setIsOpenMyModal] = useState(false);
    const [deleteTodoId, setDeleteTodoId] = useState(null);
    const [deleteTodoTitle, setDeleteTodoTitle] = useState(null);

    //search todo 
    const [searchTodo, setSearchTodo] = useState("");
    const [searchTodos, setSearchTodos] = useState(todos);
    const [searchedTodo, setSearchedTodo] = useState("");

    //current functionality - search or sort
    const [currentFunctionality, setCurrentFunctionality] = useState("none");

    const [todosLoading, setTodosLoading] = useState(false);

    //send todo via email - MyModal
    const [isSendLoading, setIsSendLoading] = useState(false);
    const [sendTodoId, setSendTodoId] = useState(null);
    const [isOpenSendMyModal, setIsOpenSendMyModal] = useState(false);







    //----------- Edit Todo ModalForm start ---------

    const handleEditOpenModal = (todoId, title, todoCompletionStatus) => {
        if (todoCompletionStatus) {
            handleOpenModalAlert();
        }
        else {
            setEditTodoId(todoId);
            setIsOpenModalForm(true);
            setModalInput(title);
        }
    }


    const handleCloseModalForm = () => {
        setIsOpenModalForm(false);
    }


    //edit todo
    const handleSubmitModalClick = () => {
        if (modalInput.length > 0) {
            handleCloseModalForm();
            editTodo(editTodoId, user._id, token, { title: modalInput }).then(data => {
                if (data.error) {
                    toast.error(data.error);
                    setModalInput("");
                }
                else {
                    toast.success(data.message, { style: { width: "180px", marginLeft: "45%", } });
                    setModalInput("");
                    setTodos(data.updatedTodos);
                    setIsEdited(!isEdited);
                    setIsTodoEdited(!isTodoEdited);
                    // if (editTodoId !== activeTodo) {
                    //     handleTasks(editTodoId);
                    // }
                }
            })
        }
    }



    const handleCancelModalClick = () => {
        handleCloseModalForm();
    }


    const handleOpenModalAlert = () => {
        setIsOpenModalAlert(true);
    }


    const handleCloseModalAlert = () => {
        setIsOpenModalAlert(false);
    }


    //enter key press to submit - edit todo 
    const handleKeyDownEditTodo = (event) => {
        if (event.key === "Enter") {
            handleSubmitModalClick();
        }
    }


    //----------- Edit Todo ModalForm end ---------






    //------------ Add Task ModalForm start ------------------

    const handleAddOpenModal = (todoId) => {
        setAddTodoId(todoId);
        setIsOpenAddModalForm(true);
    }


    const handleCloseAddModalForm = () => {
        setIsOpenAddModalForm(false);
    }


    const handleSubmitAddModalClick = () => {
        if (addModalInput.length > 0) {
            handleCloseAddModalForm();
            createTask(addTodoId, user._id, token, { task: addModalInput }).then(data => {
                if (data.error) {
                    toast.error(data.error);
                    setAddModalInput("");
                }
                else {
                    toast.success(data.message, { style: { width: "180px", marginLeft: "45%", } });
                    setIsTaskAdded(!isTaskAdded)
                    setAddModalInput("");
                    if(addTodoId !== activeTodo) {
                        handleTasks(addTodoId);
                    }
                }
            })
        }
    }


    const handleCancelAddModalClick = () => {
        handleCloseAddModalForm();
    }


    //enter key press to submit - add todo task
    const handleKeyDownAddTodoTask = (event) => {
        if (event.key === "Enter") {
            handleSubmitAddModalClick();
        }
    }


    //--------------- Add Task ModalForm end ---------------------








    // ----------- Delete Todo MyModal start --------------

    const handleDeleteOpenModal = (todoId, title) => {
        setDeleteTodoId(todoId);
        setIsOpenMyModal(true);
        setDeleteTodoTitle(title);
    }


    const handleDeleteTodoMyModal = () => {
        handleCloseMyModal();
        deleteTodo(deleteTodoId, user._id, token).then(data => {
            if (data.error) {
                toast.error(data.error, {
                    style: { width: "240px", marginLeft: "70px" }
                });
            }
            else {
                toast.success(data.message, { style: { width: "180px", marginLeft: "45%", } });
                setIsDeleted(!isDeleted)
                setTodos(data.todosAfterDeletion)
                if (data.todosAfterDeletion.length === 0) {
                    setIsTodos(false);
                }
                setFindTodo(null);
                setActiveTodo(false);
            }
        })
    }



    const handleCancelMyModal = () => {
        handleCloseMyModal();
    }



    const handleCloseMyModal = () => {
        setIsOpenMyModal(false);
    }

    // ----------- Delete Todo MyModal end --------------





    // ----------- Todo Completion Status start --------------

    const handleTodoStatus = (e, todoId) => {
        const todoStatus = e.target.checked;
        editTodoStatus(todoId, user._id, token, { todoCompletionStatus: todoStatus }).then(data => {
            if (data.error) {
                toast.error(data.error);
            }
            else {
                toast.success(data.message);
                setIsTodoCompleted(!isTodoCompleted);
                setIsTodoChecked(!isTodoChecked);
                setTodos(data.updatedTodos);
                // if (todoId !== activeTodo) {
                //     handleTasks(todoId);
                // }
            }
        })
    }

    // ----------- Todo Completion Status end --------------





    //To send todoId to tasklist 
    const handleTasks = (todoId) => {
        setFindTodo(todoId === findTodo ? null: todoId );
        setIsTodoClicked(todoId === isTodoClicked ? null : todoId);
        setActiveTodo(todoId === activeTodo ? null : todoId)
    }




    // ----------- Sort Todo start --------------

    const handleOpenSortDD = () => {
        setIsOpenSort(!isOpenSort);
    }


    const sortByDefault = () => {
        setSortOption("Default");
    }


    const sortByDateCreatedOld = () => {
        const todoCreatedOld = [...todos].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        setSortOption("Default");
        setSortedTodos(todoCreatedOld);
        setIsOpenSort(false);
        setCurrentFunctionality("sort");

    }


    const sortByDateCreatedNew = () => {
        const todoCreatedNew = [...todos].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setSortOption("Date created - new to old");
        setSortedTodos(todoCreatedNew);
        setIsOpenSort(false);
        setCurrentFunctionality("sort");
    }


    const sortByDateModifiedOld = () => {
        const todoUpdatedOld = [...todos].sort((a, b) => new Date(a.updatedAt) - new Date(b.updatedAt));
        setSortOption("Date modified - old to new");
        setSortedTodos(todoUpdatedOld);
        setIsOpenSort(false);
        setCurrentFunctionality("sort");
    }


    const sortByDateModifiedNew = () => {
        const todoUpdatedNew = [...todos].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        setSortOption("Date modified - new to old");
        setSortedTodos(todoUpdatedNew);
        setIsOpenSort(false);
        setCurrentFunctionality("sort");
    }




    const sortByDeadlineDateUpcoming = () => {
        const todoDueDateUpcoming = [...todos].sort((a, b) => {
            const today = new Date().setHours(0, 0, 0, 0);
            const aDueDate = new Date(a.deadlineDate).setHours(0, 0, 0, 0);
            const bDueDate = new Date(b.deadlineDate).setHours(0, 0, 0, 0);
            if (aDueDate === today && bDueDate !== today) return -1;
            if (aDueDate !== today && bDueDate === today) return 1;
            if (aDueDate > today && bDueDate < today) return -1;
            if (aDueDate <= today && bDueDate > today) return 1;
            if (aDueDate === today && bDueDate === today) return 0;

            return aDueDate - bDueDate;
        });
        setSortOption("Upcoming deadlines");
        setSortedTodos(todoDueDateUpcoming);
        setIsOpenSort(false);
        setCurrentFunctionality("sort");
    }


    


    const sortByDeadlineDateFuture = () => {
        const todoDueDateFuture = [...todos].sort((a, b) => new Date(b.deadlineDate) - new Date(a.deadlineDate));
        setSortOption("Future deadlines (far-off)");
        setSortedTodos(todoDueDateFuture);
        setIsOpenSort(false);
        setCurrentFunctionality("sort");
    }


    const sortByStatusUnchecked = () => {
        const todoStatusUnchecked = [...todos].sort((a, b) => a.todoCompletionStatus - b.todoCompletionStatus);
        setSortOption("Pending Todos");
        setSortedTodos(todoStatusUnchecked);
        setIsOpenSort(false);
        setCurrentFunctionality("sort");
    }


    const sortByStatusChecked = () => {
        const todoStatusChecked = [...todos].sort((a, b) => b.todoCompletionStatus - a.todoCompletionStatus);
        setSortOption("Completed Todos");
        setSortedTodos(todoStatusChecked);
        setIsOpenSort(false);
        setCurrentFunctionality("sort");
    }


    
    const sortByUnCheckedDeadlineDateUpcoming = () => {
        const todoUncheckedDueDateUpcoming = [...todos].sort((a, b) => {
            if (!a.todoCompletionStatus && b.todoCompletionStatus) return -1;
            if (a.todoCompletionStatus && !b.todoCompletionStatus) return 1;
            const today = new Date().setHours(0, 0, 0, 0);
            const aDueDate = new Date(a.deadlineDate).setHours(0, 0, 0, 0);
            const bDueDate = new Date(b.deadlineDate).setHours(0, 0, 0, 0);
            if (aDueDate === today && bDueDate !== today) return -1;
            if (aDueDate !== today && bDueDate === today) return 1;
            if (aDueDate > today && bDueDate < today) return -1;
            if (aDueDate <= today && bDueDate > today) return 1;
            if (aDueDate === today && bDueDate === today) return 0;
            if (aDueDate === bDueDate) return 0;

            return aDueDate - bDueDate;
        });

        setSortOption("Pending upcoming deadlines");
        setSortedTodos(todoUncheckedDueDateUpcoming);
        setIsOpenSort(false);
        setCurrentFunctionality("sort");
    }



    const sortByCheckedDeadlineDateUpcoming = () => {
        const todoCheckedDueDateUpcoming = [...todos].sort((a, b) => {
            if (!a.todoCompletionStatus && b.todoCompletionStatus) return 1;
            if (a.todoCompletionStatus && !b.todoCompletionStatus) return -1;
            const today = new Date().setHours(0, 0, 0, 0);
            const aDueDate = new Date(a.deadlineDate).setHours(0, 0, 0, 0);
            const bDueDate = new Date(b.deadlineDate).setHours(0, 0, 0, 0);
            if (aDueDate === today && bDueDate !== today) return -1;
            if (aDueDate !== today && bDueDate === today) return 1;
            if (aDueDate > today && bDueDate < today) return -1;
            if (aDueDate <= today && bDueDate > today) return 1;
            if (aDueDate === today && bDueDate === today) return 0;
            if (aDueDate === bDueDate) return 0;

            return aDueDate - bDueDate;
        });

        setSortOption("Completed upcoming dues");
        setSortedTodos(todoCheckedDueDateUpcoming);
        setIsOpenSort(false);
        setCurrentFunctionality("sort");
    }



    const sortByCheckedPastDeadline = () => {          
        const todoCheckedPastDueDate = [...todos].sort((a, b) => {
        if (!a.todoCompletionStatus && b.todoCompletionStatus) return 1;
            const today = new Date().setHours(0, 0, 0, 0);
            const aDueDate = new Date(a.deadlineDate).setHours(0, 0, 0, 0);
            const bDueDate = new Date(b.deadlineDate).setHours(0, 0, 0, 0);
            if (aDueDate === today && bDueDate !== today) return 1;
            if (aDueDate !== today && bDueDate === today) return -1;
            if (aDueDate > today && bDueDate < today) return 1;
            if (aDueDate <= today && bDueDate > today) return -1;
            if (aDueDate === today && bDueDate === today) return 0;

            return bDueDate - aDueDate;
        });

        setSortOption("Completed past deadlines");
        setSortedTodos(todoCheckedPastDueDate);
        setIsOpenSort(false);
        setCurrentFunctionality("sort");
    }



    // ----------- Sort Todo end --------------






    //--------- due date start -----------

    const handleDeadlineChange = (event, todoId) => {
        const newDeadline = event.target.value;
        setCurrentDeadlineDate(newDeadline);
        setActiveDeadlineTodo(todoId)
    }



    const handleSaveDeadlineDate = (todoId) => {
        editTodoDeadlineDate(todoId, user._id, token, { deadlineDate: currentDeadlineDate }).then(data => {
            if (data.error) {
                toast.error(data.error);
            } else {
                toast.success(data.message, { style: { width: "290px"} });
                setTodos(data.updatedTodos);
                setActiveDeadlineTodo(null);
                setCurrentDeadlineDate(null);
                setIsDeadlineUpdated(!isDeadlineUpdated);
                setIsDateEditMode(false);
                setIsDateSaveMode(!isDateSaveMode);
                // if (todoId !== activeTodo) {
                //     handleTasks(todoId);
                // }
            }
        });
    }



    const handleCancelDeadlineDate = () => {
        setActiveDeadlineTodo("");
        setCurrentDeadlineDate("");
        setIsDateEditMode(false);
        setIsDateSaveMode(!isDateSaveMode);
    }



    const handleEditDeadlineDate = (todoId, deadlineDate) => {
        setIsDateEditMode(!isDateEditMode);
        setActiveDeadlineTodo(todoId);
        setIsDateSaveMode(!isDateSaveMode);
        setCurrentDeadlineDate(deadlineDate);
    }



    const handleDeleteDeadlineDate = (todoId) => {
        removeTodoDeadlineDate(todoId, user._id, token, { deadlineDate: "" }).then(data => {
            if (data.error) {
                toast.error(data.error);
            } else {
                toast.success(data.message, { style: { width: "290px"} });
                setActiveDeadlineTodo(todoId);
                setCurrentDeadlineDate("");
                setIsDeadlineUpdated(!isDeadlineUpdated);
                setTodos(data.updatedTodos)
            }
        });

    }

    //--------- due date end -----------







    // ----------- Send Todo MyModal start --------------

    const handleSendOpenMyModal = (todoId) => {
        setSendTodoId(todoId);
        setIsOpenSendMyModal(true);
    }


    const handleNoClickEmailTodoMyModal = () => {
        handleCloseSendMyModal();
        setIsSendLoading(true);
        sendTodoListByEmail(sendTodoId, false, user._id, token).then(data => {
            if (data.error) {
                setIsSendLoading(false);
                toast.error(data.error)
            }
            else {
                setIsSendLoading(false);
                toast.success(data.message)
            }
        })
    }



    const handleYesClickEmailTodoMyModal = () => {
        handleCloseSendMyModal();
        setIsSendLoading(true);
        sendTodoListByEmail(sendTodoId, true, user._id, token).then(data => {
            if (data.error) {
                setIsSendLoading(false);
                toast.error(data.error)
            }
            else {
                setIsSendLoading(false);
                toast.success(data.message)
            }
        })
    }


    const handleCancelSendMyModal = () => {
        handleCloseSendMyModal();
    }


    const handleCloseSendMyModal = () => {
        setIsOpenSendMyModal(false);
    }

    // ----------- Send Todo MyModal end --------------








    // ----------- Search todo start --------------

    const handleSearchValueChange = (e) => {
        const searchValue = e.target.value;
        setSearchTodo(searchValue);
        setSearchedTodo(searchValue);

        if (!(searchValue.length > 0)) {
            setSearchTodos(todos)
            return;
        }
    }



    const handleClearSearchTodo = () => {
        setCurrentFunctionality("none");
        setSearchTodo("");
        setSearchTodos(todos);
    }



    const handleSearchTodo = () => {
        if (searchTodo.length < 1) {
            toast.error("Please enter a keyword or phrase to search");
            return;
        }
        setTodosLoading(true);
        findSearchedTodo(user._id, token, searchTodo).then(data => {
            if (data.error) {
                setSearchTodos([])
                toast.error(data.error);
                setTodosLoading(false);
            }
            else {
                setSearchTodos(data.searchedTodos);
                setCurrentFunctionality("search");
                setTodosLoading(false);
            }
        })
    }



    const handleKeyDownSearchTodo = (event) => {
        if (event.key === "Enter") {
            handleSearchTodo();
        }
    }

    // ----------- Search todo end --------------







    // ----------- TodoList start --------------

    let todoList;

    if (currentFunctionality === "search") {
        todoList = searchTodos;
    }
    else if (currentFunctionality === "sort") {
        todoList = sortedTodos;
    }
    else {
        todoList = todos;
    }

    // ----------- TodoList end --------------









    // ----------- useEffect start--------------

    useEffect(() => {
        setSearchTodos([...todos]);
    }, [todos])



    useEffect(() => {
        setSortedTodos([...todos]);
        setSortOption("Default")
    }, [todos])



    useEffect(() => {
        if (currentFunctionality === "search") {
            const filtered = todos.filter(todo => {
                return todo.title.toLowerCase().includes(searchedTodo.toLowerCase());
            })
            setSearchTodos(filtered);
        }
        else if (currentFunctionality === "sort") {
            if (sortOption === "Date created (new to old)") {
                sortByDateCreatedNew();
            } else if (sortOption === "Date modified (old to new)") {
                sortByDateModifiedOld();
            }
            else if (sortOption === "Date modified (new to old)") {
                sortByDateModifiedNew();
            }
            else if (sortOption === "Upcoming deadlines") {
                sortByDeadlineDateUpcoming();
            }
            else if (sortOption === "Future deadlines (far-off)") {
                sortByDeadlineDateFuture();
            }
            else if (sortOption === "Completed Todos") {
                sortByStatusChecked();
            }
            else if (sortOption === "Pending Todos") {
                sortByStatusUnchecked();
            }
            else if (sortOption === "Pending upcoming deadlines") {
                sortByUnCheckedDeadlineDateUpcoming();
            }
            else if (sortOption === "Completed upcoming dues") {
                sortByCheckedDeadlineDateUpcoming();
            }
            else if (sortOption === "Completed past deadlines") {
                sortByCheckedPastDeadline();
            }
            else {
                sortByDateCreatedOld();
            }
        }
        else {
            //default todo
            sortByDefault();
        }
    }, [isEdited, isDeleted, isTodoCompleted, isDateSaveMode, isDeadlineUpdated])




    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".dropdown")) {
                setIsOpenSort(false);
            }
        }
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        }
    }, []);







    return (
        <>
            <section className="text-gray-600 body-font w-full h-full">
                <div className="container  w-full h-full py-2">
                    <div className=" mb-8  w-full   md:w-[740px]  smLaptop:w-full   lg:w-full   xl:w-full    flex flex-col text-center">
                        <h1 className="xs:text-xl  sm:text-2xl   md:text-3xl font-medium title-font mb-2 text-gray-900">
                            <span className='text-[#356496]  '>Todo List</span> <FontAwesomeIcon icon={faFileLines} color='#ebbf49' />
                        </h1>
                    </div>

                    <SortDropdown
                        isOpenSort={isOpenSort}
                        trigger={<button onClick={handleOpenSortDD}>
                            Sort by: <span className='font-bold'> {sortOption} <span><FontAwesomeIcon icon={faSortDown} className='mb-[2px]   ml-[5px]' /> </span>  </span>
                        </button>}
                        menuu={[
                            <button onClick={sortByDateCreatedOld}>Default</button>,
                            <button onClick={sortByDateCreatedNew}>Date created (new to old)</button>,
                            <button onClick={sortByDateModifiedOld}>Date modified (old to new)</button>,
                            <button onClick={sortByDateModifiedNew}>Date modified (new to old)</button>,
                            <button onClick={sortByUnCheckedDeadlineDateUpcoming}>Pending upcoming deadlines</button>,
                            <button onClick={sortByCheckedDeadlineDateUpcoming}>Completed upcoming dues</button>,
                            <button onClick={sortByCheckedPastDeadline}>Completed past deadlines</button>,
                            <button onClick={sortByDeadlineDateUpcoming}>Upcoming deadlines</button>,
                            <button onClick={sortByDeadlineDateFuture}>Future deadlines (far-off)</button>,
                            <button onClick={sortByStatusUnchecked}>Pending Todos</button>,
                            <button onClick={sortByStatusChecked}>Completed Todos</button>,
                        ]}
                    />

                    <div className=' mt-14 py-1   w-[240px] mt-[120px]   xs:w-[270px] xs:mt-[120px]   sm:w-[270px] sm:mt-[120px]    md:w-[745px] md:py-2 md:mt-14   smLaptop:w-[630px] smLaptop:mt-14 smLaptop:py-2    lg:w-[745px] lg:mt-14  xl:w-[500px] xl:mt-14 xl:py-2   '>
                        <div className='flex  w-[230px]  xs:w-[260px]   sm:w-[260px]   md:w-[380px] smLaptop:w-[320px]  lg:w-[380px]  xl:w-[380px]'>
                            <div className='flex'>
                                <FontAwesomeIcon icon={faMagnifyingGlass} className='ml-4 mt-3   xs:ml-4 xs:mt-3   sm:ml-5 sm:mt-3     md:ml-6 md:mt-3     smLaptop:ml-6 smLaptop:mt-3     lg:ml-10 lg:mt-3  xl:ml-10 xl:mt-3 absolute text-blue-400' />
                                <input type="text" value={searchTodo} onChange={handleSearchValueChange} onKeyDown={handleKeyDownSearchTodo} className=' w-[130px] ml-4 pl-4 pr-1   xs:w-[160px] xs:ml-3 xs:pl-6 md:pr-1   sm:w-[150px] sm:ml-4 sm:pl-6 sm:pr-1   md:w-[250px] md:ml-4 md:pl-7 md:pr-1   smLaptop:w-[200px] smLaptop:ml-4 smLaptop:pl-7 smLaptop:pr-1   lg:ml-8 lg:px-2 lg:w-[250px] lg:pl-7 lg:pr-1    xl:w-[250px] xl:ml-8 xl:pl-7 xl:pr-1    border border-[#356496] focus:outline-[#73b2fa]  border border-blue-400 rounded-l' placeholder='Search todo...' />
                            </div>
                            <button className='px-4 py-2   xl:px-6 xl:py-2 bg-blue-300 text-white hover:bg-blue-400 rounded-r' onClick={handleSearchTodo}>Search</button>
                        </div>
                        <button className=' mt-1 ml-[100px]   sm:ml-[100px]    md:ml-[220px] text-xs text-blue-700 hover:text-red-500' onClick={handleClearSearchTodo}>clear search</button>
                    </div>

                    <div className="container mt-[30px] w-full h-[520px]    xs:mt-[30px] xs:w-full xs:h-[520px]    mobSm:mt-[30px] mobSm:w-full mobSm:h-[520px]    sm:w-full sm:h-[560px] sm:mt-[20px]    mobLg:w-full mobLg:h-[560px] mobLg:mt-[20px]    md:mt-[70px] md:w-full md:h-[560px]   smLaptop:w-full smLaptop:h-[560px]   lg:w-[744px] lg:h-[557px]   xl:w-full xl:h-[582px]">
                        <table className="text-left w-[270px] h-[515px] mx-auto     xs:w-[350px] xs:h-[515px]    mobSm:w-[410px] mobSm:h-[515px]     sm:w-[470px] sm:h-[558px]     mobLg:w-[610px] mobLg:h-[558px]    md:w-[715px] md:h-[560px]    smLaptop:w-[600px] smLaptop:h-[560px]  lg:w-[740px] lg:h-[554px]    xl:w-[790px] xl:h-[582px] xl:mx-auto   shadow-lg rounded-b border-2 border-[#ebeef7]">
                            <thead className="w-[270px]   xs:w-[350px]    mobSm:w-[410px]    sm:w-[470px]    mobLg:w-[610px]   md:w-[715px]   smLaptop:w-[602px] lg:w-full  xl:w-full   bg-[#c1cae3] flex text-white ">
                                <tr className="text-xs   xs:text-xs   sm:text-sm  mobLg:text-[16px]   md:text-[16px]  smLaptop:text-[16px]  lg:text-[16px] xl:text-[17px]   flex w-full mt-4 mb-2 text-center">
                                    <th className="py-4 w-[70px]     xs:w-[70px]   sm:w-[70px]     md:w-[70px]   smLaptop:w-[70px]  lg:w-[70px]     xl:w-[70px] ">Status</th>
                                    <th className="py-4  w-[90px]     xs:pl-2 xs:w-[120px] sm:pl-2 sm:w-[220px] md:pl-10 md:w-[260px]  smLaptop:pl-10 smLaptop:w-[260px]   lg:pl-10  lg:w-[240px]  xl:pl-10 xl:w-[260px]">Todo</th>
                                    <th className="py-4  w-[155px]      xs:w-[200px] sm:w-[180px] md:w-[150px] smLaptop:w-[150px] lg:w-[150px] xl:w-[155px] ">Due date</th>
                                    <th className="hidden xs:flex py-4  w-[100px]     xs:w-[100px] sm:w-[100px] md:w-[100px] smLaptop:w-[100px] lg:w-[100px] xl:w-[100px] ">Reminder</th>
                                    <th className="py-4  w-[60px]   xs:w-[60px]  sm:w-[60px]  md:w-[60px]  smLaptop:w-[60px]       lg:w-[60px] xl:w-[60px]     ">Add Task</th>
                                    <th className="py-4 w-[60px]    xs:w-[60px]  sm:w-[60px]  md:pl-2 md:w-[60px]  lg:w-[60px] xl:w-[60px]    ">Edit</th>
                                    <th className="py-4 w-[60px]    xs:w-[60px] xs:break-all  sm:w-[60px] sm:break-all  mobLg:hidden   ">Del</th>
                                    <th className="hidden   py-4 w-[60px]  mobLg:block mobLg:py-4   md:block md:py-4 md:pl-2 md:break-normal md:w-[60px] lg:w-[60px] xl:w-[60px]  ">Delete</th>
                                </tr>
                            </thead>

                            <tbody className=" h-[428px]  xs:h-[428px] sm:h-[458px]  md:h-[460px] smLaptop:h-[460px]  lg:h-[458px]  xl:h-[482px]  bg-grey-light flex flex-col items-center overflow-y-auto w-full">
                                {todosLoading ? (
                                    <>
                                        <tr>
                                            <td colSpan="7" rowSpan="4">
                                                <MagnifyingGlass
                                                    visible={true}
                                                    height="80"
                                                    width="80"
                                                    ariaLabel="MagnifyingGlass-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClass="MagnifyingGlass-wrapper"
                                                    glassColor='#c0efff'
                                                    color='#9cb3f0'
                                                />
                                            </td>
                                        </tr>
                                    </>
                                ) : (

                                    <>
                                        {todoList && (todoList.map((todoItem) => {
                                            const { _id, title, todoCompletionStatus, deadlineDate } = todoItem;
                                            let prevDeadline = moment(deadlineDate).format('YYYY-MM-DD');
                                            if (prevDeadline === "Invalid date") {
                                                prevDeadline = "";
                                            }
                                            const words = title.split(' ');
                                            const shouldBreakWords = words.some((word) => word.length > 30);
                                            return (
                                                <tr key={_id} className={`flex  text-xs   xs:text-xs  sm:text-sm  mobLg:text-[15px]  md:text-[15px]  smLaptop:text-[15px]  lg:text-[15px] xl:text-[16px] xl:leading-[24px]    w-full mb-4 hover:bg-[#f5f7fa]  ${isTodoClicked === _id ? 'bg-[#f0f4fa]' : ""}`}>
                                                    <td className=" py-4  w-[20px]   xs:w-[30px] xs:px-1  mobSm:w-[30px] mobSm:px-1  sm:w-[40px] sm:px-2   mobLg:w-[40px] mobLg:px-2   md:p-4 md:w-[60px]   smLaptop:px-2 smLaptop:py-4 smLaptop:w-[40px]    lg:p-4 lg:w-[60px]">
                                                        <div data-tooltip-id="todo-status-tooltip" data-tooltip-content="Todo Completion Status">
                                                            <Checkbox checked={todoCompletionStatus} onChange={(e) => handleTodoStatus(e, _id)} checkboxContainerClass="checkbox-container" checkmarkClass="checkmark" />
                                                        </div>
                                                        <Tooltip id="todo-status-tooltip" place="bottom" style={{ backgroundColor: "#e1e7f0", color: "#1f4578", padding: "2px 5px", fontSize: "12px" }} />
                                                    </td>
                                                    <td className={`py-4  w-[50px]  xs:w-[60px]  mobSm:w-[90px]   sm:w-[140px] mobLg:w-[210px]   md:py-4 md:w-[250px]    smLaptop:py-4 smLaptop:w-[215px]    lg:py-4 lg:w-[240px] lg:px-0   xl:py-4 xl:w-[270px]  ${shouldBreakWords ? 'break-all' : ""} `}>
                                                        <button onClick={() => handleTasks(_id)} className='text-left' data-tooltip-id="todo-title-tooltip" data-tooltip-content="Title">
                                                            <FontAwesomeIcon icon={isTodoClicked === _id ? faFolderOpen : faFolderClosed} className='mr-2' color='#ebbf49' />
                                                            {title}
                                                        </button>
                                                        <Tooltip id="todo-title-tooltip" place="bottom" style={{ backgroundColor: "#e1e7f0", color: "#1f4578", padding: "2px 10px", fontSize: "12px" }} />
                                                    </td>
                                                    <td className=" py-4 w-[110px]   xs:w-[120px]   mobSm:w-[120px] sm:w-[125px] mobLg:w-[140px]  md:py-4 md:w-[140px] md:px-2   smLaptop:w-[120px] smLaptop:px-2 smLaptop:py-4    lg:pl-4 lg:pr-2 lg:py-4 lg:w-[150px]  xl:pl-4 xl:pr-2 xl:py-4 xl:w-[150px] text-center ">
                                                        <input type="date" value={activeDeadlineTodo === _id ? currentDeadlineDate : prevDeadline} onChange={(event) => handleDeadlineChange(event, _id)} disabled={isDateEditMode && (activeDeadlineTodo === _id) ? "" : "disabled"} />
                                                        {isDateSaveMode && (activeDeadlineTodo === _id) ? (
                                                            <>
                                                                <span onClick={() => handleSaveDeadlineDate(_id)} className='inline-block px-2 py-1 text-xs font-bold leading-none text-green-800 bg-green-100 cursor-pointer rounded-full mr-1'>save</span>
                                                                <span onClick={() => handleCancelDeadlineDate(_id)} className='inline-block px-2 py-1 text-xs font-bold leading-none text-red-900 bg-red-200 cursor-pointer rounded-full'>cancel</span>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span onClick={() => handleEditDeadlineDate(_id, prevDeadline)} className='inline-block px-2 py-1 text-xs font-bold leading-none text-blue-800 bg-blue-100 cursor-pointer rounded-full mr-1'>edit</span>
                                                                <span onClick={() => handleDeleteDeadlineDate(_id)} className='inline-block px-2 py-1 text-xs font-bold leading-none text-red-800 bg-red-100 cursor-pointer rounded-full mr-1'>delete</span>
                                                            </>
                                                        )}
                                                    </td>
                                                    <td className=" py-4  hidden  xs:block  xs:w-[50px]   mobSm:w-[65px]  sm:w-[60px] mobLg:w-[70px] md:py-4 md:w-[70px]  smLaptop:py-4 smLaptop:w-[70px]    lg:py-4 lg:px-2 lg:w-[100px] text-center  ">
                                                        <button onClick={() => handleSendOpenMyModal(_id)}
                                                            data-tooltip-id="my-tooltip" data-tooltip-content="Send Todo via email"
                                                            className="relative px-3 py-1 text-white rounded-full shadow-lg shadow-blue-200 
                                                                    bg-gradient-to-r from-blue-300 to-blue-400 
                                                                    hover:from-blue-400 hover:to-blue-500 
                                                                    transition duration-300 ease-in-out">Send</button>
                                                        <Tooltip id="my-tooltip" place="bottom" style={{ backgroundColor: "#e1e7f0", color: "#1f4578", padding: "2px 5px", fontSize: "12px" }} />
                                                    </td>
                                                    <td className=" py-4 w-[30px]  xs:w-[30px] mobSm:w-[35px] sm:w-[35px]  mobLg:w-[50px]  md:py-4 md:w-[65px]  smLaptop:py-4 smLaptop:w-[50px]      lg:px-2 lg:py-4 lg:w-[60px] text-center">
                                                        <button onClick={() => handleAddOpenModal(_id)} data-tooltip-id="add-todo-task-tooltip" data-tooltip-content="Add Task">
                                                            <FontAwesomeIcon icon={faCirclePlus} color='#59bd69' className='text-lg' />
                                                        </button>
                                                        <Tooltip id="add-todo-task-tooltip" place="bottom" style={{ backgroundColor: "#e1e7f0", color: "#1f4578", padding: "2px 5px", fontSize: "12px" }} />
                                                    </td>
                                                    <td className=" py-4 w-[30px] xs:w-[30px] mobSm:w-[35px] sm:w-[35px] mobLg:w-[50px] md:py-4 md:w-[65px] smLaptop:py-4 smLaptop:w-[50px]    lg:px-2 lg:py-4 lg:w-[60px] text-center">
                                                        <button onClick={() => handleEditOpenModal(_id, title, todoCompletionStatus)} data-tooltip-id="edit-todo-tooltip" data-tooltip-content="Edit Todo">
                                                            <FontAwesomeIcon icon={faPenToSquare} color='#4d80e8' className='text-lg' />
                                                        </button>
                                                        <Tooltip id="edit-todo-tooltip" place="bottom" style={{ backgroundColor: "#e1e7f0", color: "#1f4578", padding: "2px 5px", fontSize: "12px" }} />
                                                    </td>
                                                    <td className="  py-4 w-[30px] xs:w-[30px] mobSm:w-[35px] sm:w-[35px] mobLg:w-[50px] md:py-4 md:w-[65px]   smLaptop:py-4 smLaptop:w-[50px]       lg:px-2 lg:py-4 lg:w-[60px] text-center">
                                                        <button onClick={() => handleDeleteOpenModal(_id, title)} data-tooltip-id="delete-todo-tooltip" data-tooltip-content="Delete Todo">
                                                            <FontAwesomeIcon icon={faTrash} color="#fc2717" />
                                                        </button>
                                                        <Tooltip id="delete-todo-tooltip" place="bottom" style={{ backgroundColor: "#e1e7f0", color: "#1f4578", padding: "2px 5px", fontSize: "12px" }} />
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        )
                                        )}
                                    </>
                                )}
                            </tbody>
                        </table>



                        {addTodoId ? (
                            <ModalForm
                                isOpenModalForm={isOpenAddModalForm}
                                onCloseModal={handleCloseAddModalForm}
                                onSubmitModalClick={handleSubmitAddModalClick}
                                submitText="Add task"
                                onKeyDownModal={handleKeyDownAddTodoTask}
                                onCancelModalClick={handleCancelAddModalClick}
                                modalFormMessage="Please enter subtask to be added"
                                modalInput={addModalInput}
                                setModalInput={setAddModalInput}
                            />
                        ) : null}


                        {editTodoId ? (
                            <ModalForm
                                isOpenModalForm={isOpenModalForm}
                                onCloseModal={handleCloseModalForm}
                                onSubmitModalClick={handleSubmitModalClick}
                                submitText="Save changes"
                                onKeyDownModal={handleKeyDownEditTodo}
                                onCancelModalClick={handleCancelModalClick}
                                modalFormMessage="Please enter Todo title"
                                modalInput={modalInput}
                                setModalInput={setModalInput}
                            />
                        ) : null}


                        {isOpenModalAlert ? (
                            <ModalAlert
                                isOpenModalAlert={isOpenModalAlert}
                                handleCloseModalAlert={handleCloseModalAlert}
                                modalAlertMessage="Sorry, you cannot edit a completed Todo."
                                modalAlertSubMessage="If you still want to edit it, please uncheck the status and try again."
                            />
                        ) : null}


                        {deleteTodoId ? (
                            <>
                                <MyModal
                                    isOpenMyModal={isOpenMyModal}
                                    onCloseMyModal={handleCloseMyModal}
                                    onYesModalClick={handleDeleteTodoMyModal}
                                    onNoModalClick={handleCloseMyModal}
                                    onCancelMyModal={handleCancelMyModal}
                                    modalQuestion={`Are you sure you want to delete '${deleteTodoTitle.length < 80 ? `${deleteTodoTitle}` : `${deleteTodoTitle.substring(0, 32)}...` }'?  `}
                                />
                            </>
                        ) : null}


                        {sendTodoId ? (
                            <>
                                <MyModal
                                    isOpenMyModal={isOpenSendMyModal}
                                    onCloseMyModal={handleCloseSendMyModal}
                                    onYesModalClick={handleYesClickEmailTodoMyModal}
                                    onNoModalClick={handleNoClickEmailTodoMyModal}
                                    onCancelMyModal={handleCancelSendMyModal}
                                    modalQuestion="Do you want subtasks to be sent by email along with the todo?"
                                />
                            </>
                        ) : null}


                        {isSendLoading && <LoadingOverlay />}

                    </div>

                </div>

            </section>
        </>
    )
}




export default TodoList;